import { Box, styled } from '@leagueplatform/genesis-core';
import { MasonryCarouselRenderer } from '@leagueplatform/masonry-renderers';

const CARD_WIDTH = {
  desktop: '384px',
  mobile: '320px',
} as const;

const Container = styled(Box, {
  display: 'contents',
  variants: {
    hasMultipleItems: {
      true: {
        '& ul > li': {
          maxWidth: CARD_WIDTH.desktop,
          minWidth: CARD_WIDTH.desktop,
          '@mobile': {
            minWidth: CARD_WIDTH.mobile,
          },
        },
      },
    },
  },
});

type MasonryCarouselRendererProps = React.ComponentProps<
  typeof MasonryCarouselRenderer
>;

export const RewardProgramsCarousel = (props: MasonryCarouselRendererProps) => {
  const { items, ...rest } = props;
  const hasMultipleItems = items.length >= 2;

  return (
    <Container hasMultipleItems={hasMultipleItems}>
      <MasonryCarouselRenderer
        items={items}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    </Container>
  );
};
